// skipcq: JS-W1028
import Chip from '@mui/material/Chip';
import PropTypes from 'prop-types';

import { DETAIL_MUTED } from '../../utils/theme';

function ReviewDetailsUnreadCountChip({ count, showReviewedWhenZero = false }) {
  const normalizedCount = typeof count === 'number' && Number.isFinite(count) ? count : 0;
  if (normalizedCount <= 0) {
    if (!showReviewedWhenZero) {
      return null;
    }

    return (
      <Chip
        label="Reviewed"
        size="small"
        aria-label="All reviews reviewed"
        sx={{
          bgcolor: 'action.hover',
          color: DETAIL_MUTED,
          fontWeight: 500,
          height: 22,
        }}
      />
    );
  }

  return (
    <Chip
      label={String(normalizedCount)}
      size="small"
      aria-label={`${normalizedCount} unread reviews`}
      sx={{
        bgcolor: '#F9DA85',
        color: 'text.primary',
        fontWeight: 600,
        minWidth: 28,
        height: 22,
      }}
    />
  );
}

ReviewDetailsUnreadCountChip.propTypes = {
  count: PropTypes.number,
  showReviewedWhenZero: PropTypes.bool,
};

export default ReviewDetailsUnreadCountChip;
